/**
 * @Description 失效页
 */
import { FC } from 'react';
import styles from './entry.module.less';
const Failure: FC<{}> = () => {
  return (
    <div className={styles.container}>
      <div>
        <div className={styles.imgCon}>
          <img
            src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/img_share_failure@2x.png`}
            width='100%'
            height='100%'/>
        </div>
        <div className='fs-32 c-999 mt-32'>
          链接已失效
        </div>
      </div>
    </div>
  );
};

export default Failure;

